import { render, staticRenderFns } from "./ViewTaggedData.vue?vue&type=template&id=5c35cab2&"
import script from "./ViewTaggedData.vue?vue&type=script&lang=js&"
export * from "./ViewTaggedData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports